import React, { useState } from "react";
import "../../styles/PagesStyling/DashBoard.css";
import { useNavigate } from "react-router-dom";

import ElasticSearchCard from "../DashboardComponents/ElasticSearchCard";

export const Dashboard = ({
  isLoggedIn,
  setLoggedIn,
  userData,
  setUserData,
}) => {
  const navigate = useNavigate();

  // Parent-level states for sponsor and project
  const [selectedSponsor, setSelectedSponsor] = useState("All");
  const [selectedProject, setSelectedProject] = useState("All");

  // Redirect if user is not logged in or missing user data
  if (!isLoggedIn || !userData) {
    console.error("Not logged in or user data not available.");
    navigate("/");
    return null; // Stop rendering here
  }

  return (
    <div className="dashboard-container">
      {/* ElasticSearchCard under the dropdowns */}
      <ElasticSearchCard
        userData={userData}
        setUserData={setUserData}
        isLoggedIn={isLoggedIn}
        setIsLoggedIn={setLoggedIn}
        selectedSponsor={selectedSponsor}
        selectedProject={selectedProject}
        setSelectedProject={setSelectedProject}
        setSelectedSponsor={setSelectedSponsor}
        onSponsorChange={setSelectedSponsor}
      />
    </div>
  );
};
